import { type ReactElement } from "react"

import CamerasLoader from "./CamerasLoader"
import PageTitle from "@/Components/PageTitle"


const CamerasNew = (): ReactElement => {
  return (
    <>
      <PageTitle>Cameras</PageTitle>
      <div className='p-10 flex flex-col h-full'>
        <h1 className='text-4xl font-bold'>Cameras</h1>
        <div className='relative h-full -mx-10 px-10'>
          <CamerasLoader />
        </div>
      </div>
    </>
  )
}

export default CamerasNew